<template>
    <span v-if="remoteFile.accepted" class="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
    <span v-else-if="remoteFile.declined" class="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
    <span v-else-if="remoteFile.viewed" class="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
    <span v-else class="relative inline-flex rounded-full h-2 w-2 bg-gray-300"></span>
</template>

<script>
export default {
    props: {
        remoteFile: Object
    }
}
</script>
